export default __webpack_public_path__ + "static/media/card5_right.a55bcb11.png";